import { numberToPrettyString } from '@cian/utils';

export function formatMoney(money: number): string {
  return `${numberToPrettyString(money)}`;
}
